import React from "react"
import { Reveal } from "react-reveal"
const BlogList = ({ data }) => {
  const edges = data.allContentfulBlogPost.edges

  return edges.map((edge, index) => {
    const date = edge.node.timestamp.split(",")

    const  day_month = date[0].split(" ")

    return (
      <Reveal bottom>
        <article key={index} className="blog-item">
          <div className="blog-item-img">
            <img className="card-img rounded-0" src={edge.node.image.gatsbyImageData.images.fallback.src} />
            <a href="/blog/#" className="blog-item-date">
              <h3>{day_month[0]}</h3>
              <p>{day_month[1]}</p>
            </a>
          </div>
          <div className="blog-details">
            <a className="d-inline-block" href={`/blog/${edge.node.id}`}>
              <h2>{edge.node.title}</h2>
            </a>
            <p>{edge.node.summary}</p>
          </div>
        </article>
      </Reveal>
    )
  })
}

export default BlogList
